import React from "react";
import { SpsI } from "@spscommerce/ds-react";
import { SpsIcon as SpsIcons } from "@spscommerce/ds-shared";

export type PasswordIconProps = {
    valid: boolean;
};

export function PasswordIcon({ valid }: PasswordIconProps) {
    return (
        <>
            {valid ? (
                <SpsI className="password-circle" icon={SpsIcons.STATUS_OK} />
            ) : (
                <SpsI className="password-circle" icon={SpsIcons.CIRCLE_OUTLINE} />
            )}
        </>
    );
}
